// extracted by mini-css-extract-plugin
export default {"contentWrapper":"style_contentWrapper__Nbv6T","toCapitalize":"style_toCapitalize__0PLno"};